import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-10" }
const _hoisted_2 = { class: "col span-6" }
const _hoisted_3 = {
  key: 0,
  class: "col span-6"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import LabeledSelect from '@shell/components/form/LabeledSelect';
import { LabeledInput } from '@components/Form/LabeledInput';
import { Checkbox } from '@components/Form/Checkbox';
import { Banner } from '@components/Banner';
import { _CREATE } from '@shell/config/query-params';
import { IO_THREADS_POLICIES, DEFAULT_IO_THREAD_COUNT, UNSET_IO_THREAD_COUNT } from './storage-options';


export default /*@__PURE__*/_defineComponent({
  __name: 'VmStorageOptions',
  props: {
    blockMultiQueue: { type: Boolean, default: false },
    ioThreadsPolicy: { default: '' },
    ioThreadCount: { default: '' },
    hasDedicatedIoThread: { type: Boolean, default: false },
    mode: { default: _CREATE },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:blockMultiQueue", "update:ioThreadsPolicy", "update:ioThreadCount"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const { t } = useI18n(store);

const ioThreadsPolicyOptions = computed(() => IO_THREADS_POLICIES.map((value) => ({
  label: t(`cluster.credential.harvester.vmStorageOptions.ioThreadsPolicy.${ value || 'default' }`),
  value,
})));

function setIoThreadsPolicy(policy: string) {
  emit('update:ioThreadsPolicy', policy);

  // The driver only accepts a thread count with the supplemental pool policy
  if (policy === 'supplementalPool') {
    if (!(Number(props.ioThreadCount) >= 1)) {
      emit('update:ioThreadCount', DEFAULT_IO_THREAD_COUNT);
    }
  } else if (Number(props.ioThreadCount)) {
    // Back to the schema default rather than empty: Rancher hashes "" and "0" differently, so a pool that ends
    // up where it started would otherwise roll out its machines
    emit('update:ioThreadCount', UNSET_IO_THREAD_COUNT);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Checkbox), {
      value: __props.blockMultiQueue,
      "data-testid": "vm-storage-options-block-multi-queue",
      class: "mb-10",
      label: _unref(t)('cluster.credential.harvester.vmStorageOptions.blockMultiQueue.label'),
      tooltip: _unref(t)('cluster.credential.harvester.vmStorageOptions.blockMultiQueue.tip'),
      mode: __props.mode,
      disabled: __props.disabled,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:blockMultiQueue', $event)))
    }, null, 8, ["value", "label", "tooltip", "mode", "disabled"]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(LabeledSelect), {
          value: __props.ioThreadsPolicy,
          "data-testid": "vm-storage-options-io-threads-policy",
          label: _unref(t)('cluster.credential.harvester.vmStorageOptions.ioThreadsPolicy.label'),
          tooltip: _unref(t)('cluster.credential.harvester.vmStorageOptions.ioThreadsPolicy.tip'),
          options: ioThreadsPolicyOptions.value,
          mode: __props.mode,
          disabled: __props.disabled,
          "onUpdate:value": setIoThreadsPolicy
        }, null, 8, ["value", "label", "tooltip", "options", "mode", "disabled"])
      ]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      (__props.ioThreadsPolicy === 'supplementalPool')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(LabeledInput), {
              value: __props.ioThreadCount,
              "data-testid": "vm-storage-options-io-thread-count",
              type: "integer",
              min: "1",
              required: true,
              label: _unref(t)('cluster.credential.harvester.vmStorageOptions.ioThreadCount.label'),
              tooltip: _unref(t)('cluster.credential.harvester.vmStorageOptions.ioThreadCount.tip'),
              mode: __props.mode,
              disabled: __props.disabled,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (emit('update:ioThreadCount', String($event))))
            }, null, 8, ["value", "label", "tooltip", "mode", "disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[4] || (_cache[4] = _createTextVNode()),
    (__props.hasDedicatedIoThread && !__props.ioThreadsPolicy)
      ? (_openBlock(), _createBlock(_unref(Banner), {
          key: 0,
          color: "info",
          label: _unref(t)('cluster.credential.harvester.vmStorageOptions.ioThreadsPolicy.sharedTip')
        }, null, 8, ["label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})